<template >
  <div class="appBlock">
    <div class="steps" v-show="!prew_history">
      <a-drawer
        :title="$t('Comment')"
        placement="bottom"
        :height="heightWindow"
        @close="onClose"
        :visible="isCommentVisible"
      >
        <template>
          <a-list
            v-if="comments.length != 0"
            :dataSource="comments"
            :header="`${comments.length} ${
              comments.length > 1 ? $t('records') : $t('record')
            }`"
            itemLayout="horizontal"
          >
            <a-list-item slot="renderItem" slot-scope="item">
              <a-comment
                :author="item.FIO"
                :content="item.content"
                :datetime="item.datetime"
              >
                <a-avatar
                  slot="avatar"
                  :src="
                    item.photo == ''
                      ? 'https://voxpopulii.in/system/static/dashboard/img/default_user.png'
                      : item.photo
                  "
                  :alt="profile.NAME + ' ' + profile.LAST_NAME"
                />
              </a-comment>
            </a-list-item>
          </a-list>

          <a-comment>
            <a-avatar
              slot="avatar"
              :src="
                profile.PERSONAL_PHOTO == null
                  ? 'https://voxpopulii.in/system/static/dashboard/img/default_user.png'
                  : profile.PERSONAL_PHOTO
              "
              :alt="profile.NAME + ' ' + profile.LAST_NAME"
            />
            <div slot="content">
              <a-form-item>
                <a-textarea
                  :rows="2"
                  @change="handleChangeComment"
                  :value="valueComment"
                ></a-textarea>
              </a-form-item>
              <a-form-item style="padding-bottom: 20px">
                <a-button
                  htmlType="submit"
                  :disabled="submittingComment"
                  :loading="submittingComment"
                  @click="handleSubmitComment"
                  type="primary"
                  >{{ $t("Add Comment") }}</a-button
                >
              </a-form-item>
            </div>
          </a-comment>
        </template>
      </a-drawer>
      <a-steps :current="current">
        <a-step
          v-for="(item, index) in steps"
          :key="item.title"
          :title="
            index < current
              ? $t('Completed')
              : index == current
              ? $t('Running')
              : $t('Awaiting')
          "
          :description="item.content"
        />
      </a-steps>
    </div>
    <a-row v-show="!prew_history" style="padding: 10px 0px">
      <a-col :span="16">
        <a-button @click="handleHistoryFile">{{ $t("Change log") }}</a-button>
      </a-col>
      <a-col :span="8" style="text-align: right">
        <a-button
          v-if="element.status == 'DO OPISANIA'"
          @click="handleReturnToNew"
          :disabled="disableFromResponsible"
          type="primary"
          style="margin-right: 25px"
          >{{ $t("Back to registration") }}</a-button
        >
        <a-button
          v-if="
            (element.status == 'ZARCHIWIZOWANY' ||
              element.status == 'OPISANY') &&
            profile.ADMIN
          "
          @click="handleReturnToDesc"
          :disabled="disableFromResponsible"
          type="primary"
          style="margin-right: 25px"
          >{{ $t("Back to description") }}</a-button
        >
        <a-button
          @click="submit"
          :disabled="
            disableFromResponsible ||
            !currentEdit ||
            element.status == 'ZARCHIWIZOWANY'
          "
          type="primary"
          >{{ $t("Save") }}</a-button
        >
      </a-col>
    </a-row>
    <a-spin :spinning="spinning" size="large">
      <div style="border: 1px solid lightgray; border-radius: 5px">
        <a-row type="flex" style="padding: 15px">
          <a-col :span="10">
            <a-row type="flex" align="middle">
              <a-col>
                <!-- <a-button
                  @click="myPrint"
                  type="primary"
                  icon="printer"
                  style="margin-right: 25px;"
                >{{ $t('Print') }}</a-button>-->
                <a-tooltip>
                  <template slot="title">{{ $t("Print") }}</template>
                  <a-icon @click="myPrint" type="printer" class="iconBtn" />
                </a-tooltip>
              </a-col>
              <a-col>
                <a-upload
                  v-if="!prew_history"
                  :fileList="fileList"
                  :beforeUpload="beforeUpload"
                  :multiple="true"
                >
                  <!-- <a-button
                    :disabled="!currentEdit"
                    icon="upload"
                    :loading="uploading"
                  >{{ uploading ? 'Uploading' : $t('Add document') }}</a-button>-->
                  <a-tooltip>
                    <template slot="title">{{
                      uploading ? "Uploading" : $t("Add document")
                    }}</template>
                    <a-icon
                      :loading="uploading"
                      :disabled="!currentEdit"
                      type="upload"
                      class="iconBtn"
                    />
                  </a-tooltip>
                </a-upload>
              </a-col>
              <a-col v-if="newPages.includes(currentPage)">
                <a-button
                  style="margin-left: 25px"
                  :loading="DeletePageloading"
                  @click="showDeleteConfirm"
                  type="dashed"
                  >{{ $t("Delete Page") }}</a-button
                >
              </a-col>
            </a-row>
          </a-col>

          <a-col :span="4" :offset="2">
            <a-row
              v-if="currentEdit"
              type="flex"
              justify="center"
              align="middle"
            >
              <a-statistic-countdown
                :value="deadline"
                @finish="onFinish"
                format="mm:ss"
                style="margin-right: 10px"
              />
              <a-tooltip
                :title="$t('Time until the end of the session')"
                style="margin-right: 50px"
              >
                <a-icon type="info-circle" />
              </a-tooltip>
            </a-row>
            <span v-else style="margin-right: 50px">{{
              $t("This file is edited by") +
              " " +
              getUser(element.currentlyeditor)
            }}</span>
          </a-col>
          <a-col :span="1" :offset="7" style="text-align: right">
            <!-- <a-button type="danger" icon="close" @click="confirmClose">{{ $t('Close') }}</a-button> -->
            <a-tooltip placement="left">
              <template slot="title">{{ $t("Close") }}</template>
              <a-icon
                type="close"
                class="iconBtn iconBtnClose"
                @click="confirmClose"
              />
            </a-tooltip>
          </a-col>
        </a-row>
        <div class="mainBlock--form">
          <div class="Form" v-show="!prew_history">
            <a-spin :spinning="prew_doc_spinner" style="flex: 1">
              <div style="margin: 25px">
                <span v-if="!prew_doc">
                  <div v-if="docPdf" style="width: fit-content">
                    <a-row
                      v-show="!prew_doc_spinner"
                      type="flex"
                      justify="space-between"
                    >
                      <a-button
                        :disabled="currentPage - 1 < 1 ? true : false"
                        @click="
                          currentPage--;
                          getpdf();
                        "
                      >
                        <a-icon type="left" />
                        {{ $t("Prev") }}
                      </a-button>
                      <span>{{ currentPage }} / {{ countPages }}</span>
                      <a-button
                        :disabled="currentPage + 1 > countPages ? true : false"
                        @click="
                          () => {
                            currentPage++;
                            getpdf();
                          }
                        "
                      >
                        {{ $t("Next") }}
                        <a-icon type="right" />
                      </a-button>
                    </a-row>
                    <canvas
                      id="the_canvas_detail"
                      style="display: none"
                      @click="preview"
                    />
                    <a-row
                      v-show="!prew_doc_spinner"
                      type="flex"
                      justify="space-between"
                    >
                      <a-button
                        :disabled="currentPage - 1 < 1 ? true : false"
                        @click="
                          currentPage--;
                          getpdf();
                        "
                      >
                        <a-icon type="left" />
                        {{ $t("Prev") }}
                      </a-button>
                      <span>{{ currentPage }} / {{ countPages }}</span>
                      <a-button
                        :disabled="currentPage + 1 > countPages ? true : false"
                        @click="
                          () => {
                            currentPage++;
                            getpdf();
                          }
                        "
                      >
                        {{ $t("Next") }}
                        <a-icon type="right" />
                      </a-button>
                    </a-row>
                  </div>

                  <img
                    :src="`${
                      element.DOWNLOAD_URL != undefined
                        ? element.DOWNLOAD_URL
                        : element.url
                    }`"
                    style="width: 100%"
                    v-else
                  />
                </span>
                <a-empty v-else />
              </div>
            </a-spin>
            <div style="width: 40%">
              <firstStep
                v-if="current == 0"
                v-on:show-comments="isCommentVisible = !isCommentVisible"
                :commentsData="comments"
                :disableFromResponsible="disableFromResponsible"
                :document="element"
                :profile="profile"
                :currentEdit="currentEdit"
                :info="form_info"
                :user_setup="user_setup"
                :isPromptAvailableParent="isPromptAvailable"
                @changePromptStatus="isPromptAvailable = $event"
                ref="form"
                @onback="back"
                @changeSpinning="changeSpinning"
              />
              <secondStep
                v-else-if="current == 1"
                :document="element"
                :user_setup="user_setup"
                :commentsData="comments"
                v-on:show-comments="isCommentVisible = !isCommentVisible"
                :info="form_info"
                :responsible="responsible"
                :currentEdit="currentEdit"
                :key_words="key_words"
                :profile="profile"
                :specialization="specialization"
                ref="form"
                :isPromptAvailableParent="isPromptAvailable"
                @changePromptStatus="isPromptAvailable = $event"
                @onback="back"
                @changeSpinning="changeSpinning"
              />
              <thirdStep
                v-else
                :document="element"
                :commentsData="comments"
                v-on:show-comments="isCommentVisible = !isCommentVisible"
                :info="form_info"
                :currentEdit="currentEdit"
                :key_words="key_words"
                :specialization="specialization"
                :responsible="responsible"
                :profile="profile"
                ref="form"
                @onback="back"
                @changeSpinning="changeSpinning"
              />
              <template>
                <a-list
                  id="my_comments_styl"
                  v-if="comments.length != 0"
                  :dataSource="comments"
                  :header="`${comments.length} ${
                    comments.length > 1 ? $t('records') : $t('record')
                  }`"
                  itemLayout="horizontal"
                >
                  <a-list-item slot="renderItem" slot-scope="item">
                    <a-comment
                      :author="item.FIO"
                      :content="item.content"
                      :datetime="item.datetime"
                    >
                      <a-avatar
                        slot="avatar"
                        :src="
                          item.photo == ''
                            ? 'https://voxpopulii.in/system/static/dashboard/img/default_user.png'
                            : item.photo
                        "
                        :alt="profile.NAME + ' ' + profile.LAST_NAME"
                      />
                    </a-comment>
                  </a-list-item>
                </a-list>

                <a-comment style="padding: 0 15px">
                  <a-avatar
                    slot="avatar"
                    :src="
                      profile.PERSONAL_PHOTO == null
                        ? 'https://voxpopulii.in/system/static/dashboard/img/default_user.png'
                        : profile.PERSONAL_PHOTO
                    "
                    :alt="profile.NAME + ' ' + profile.LAST_NAME"
                  />
                  <div slot="content">
                    <a-form-item>
                      <a-textarea
                        :rows="2"
                        @change="handleChangeComment"
                        :value="valueComment"
                      ></a-textarea>
                    </a-form-item>
                    <a-form-item style="padding-bottom: 20px">
                      <a-button
                        htmlType="submit"
                        :disabled="submittingComment"
                        :loading="submittingComment"
                        @click="handleSubmitComment"
                        type="primary"
                        >{{ $t("Add Comment") }}</a-button
                      >
                    </a-form-item>
                  </div>
                </a-comment>
              </template>
            </div>
          </div>
          <documentHistory
            :document="element"
            :info="form_info"
            @back_history="back"
            v-if="prew_history"
            style="padding: 15px"
          />
        </div>
        <a-row type="flex" style="padding: 15px">
          <a-col :span="10">
            <a-row type="flex" align="middle">
              <a-col>
                <!-- <a-button
                  @click="myPrint"
                  type="primary"
                  icon="printer"
                  style="margin-right: 25px;"
                >{{ $t('Print') }}</a-button>-->
                <a-tooltip>
                  <template slot="title">{{ $t("Print") }}</template>
                  <a-icon @click="myPrint" type="printer" class="iconBtn" />
                </a-tooltip>
              </a-col>
              <a-col>
                <a-upload
                  v-if="!prew_history"
                  :fileList="fileList"
                  :beforeUpload="beforeUpload"
                  :multiple="true"
                >
                  <!-- <a-button
                    :disabled="!currentEdit"
                    icon="upload"
                    :loading="uploading"
                  >{{ uploading ? 'Uploading' : $t('Add document') }}</a-button>-->
                  <a-tooltip>
                    <template slot="title">{{
                      uploading ? "Uploading" : $t("Add document")
                    }}</template>
                    <a-icon
                      :loading="uploading"
                      :disabled="!currentEdit"
                      type="upload"
                      class="iconBtn"
                    />
                  </a-tooltip>
                </a-upload>
              </a-col>
              <a-col v-if="newPages.includes(currentPage)">
                <a-button
                  style="margin-left: 25px"
                  :loading="DeletePageloading"
                  @click="showDeleteConfirm"
                  type="dashed"
                  >{{ $t("Delete Page") }}</a-button
                >
              </a-col>
            </a-row>
          </a-col>

          <a-col :span="4" :offset="2">
            <a-row
              v-if="currentEdit"
              type="flex"
              justify="center"
              align="middle"
            >
              <a-statistic-countdown
                :value="deadline"
                @finish="onFinish"
                format="mm:ss"
                style="margin-right: 10px"
              />
              <a-tooltip
                :title="$t('Time until the end of the session')"
                style="margin-right: 50px"
              >
                <a-icon type="info-circle" />
              </a-tooltip>
            </a-row>
            <span v-else style="margin-right: 50px">{{
              $t("This file is edited by") +
              " " +
              getUser(element.currentlyeditor)
            }}</span>
          </a-col>

          <a-col :span="1" :offset="7" style="text-align: right">
            <!-- <a-button type="danger" icon="close" @click="back">{{ $t('Close') }}</a-button> -->
            <a-tooltip placement="left">
              <template slot="title">{{ $t("Close") }}</template>
              <a-icon
                type="close"
                class="iconBtn iconBtnClose"
                @click="confirmClose"
              />
            </a-tooltip>
          </a-col>
        </a-row>
      </div>
    </a-spin>
    <div class="mainBlock--btn" v-show="!prew_history">
      <a-row>
        <a-col :span="16">
          <a-button @click="handleHistoryFile">{{ $t("Change log") }}</a-button>
        </a-col>
        <a-col :span="8" style="text-align: right">
          <a-button
            v-if="element.status == 'DO OPISANIA'"
            @click="handleReturnToNew"
            :disabled="disableFromResponsible"
            type="primary"
            style="margin-right: 25px"
            >{{ $t("Back to registration") }}</a-button
          >
          <a-button
            v-if="
              (element.status == 'ZARCHIWIZOWANY' ||
                element.status == 'OPISANY') &&
              profile.ADMIN
            "
            @click="handleReturnToDesc"
            :disabled="disableFromResponsible"
            type="primary"
            style="margin-right: 25px"
            >{{ $t("Back to description") }}</a-button
          >
          <a-button
            @click="submit"
            :disabled="
              disableFromResponsible ||
              !currentEdit ||
              element.status == 'ZARCHIWIZOWANY'
            "
            type="primary"
            >{{ $t("Save") }}</a-button
          >
        </a-col>
      </a-row>
    </div>
  </div>
</template>

<script>
import firstStep from "./firstStep.vue";
import secondStep from "./secondStep.vue";
import thirdStep from "./thirdStep.vue";
import documentHistory from "./documentHistory.vue";
import {
  getHistory,
  uploadFile,
  deletePage,
  commentAdd,
  editClose,
  returnToDescription,
  returnToNew,
} from "../requestFunc";

var pdfjsLib = require("pdfjs-dist/build/pdf");
var pdfjsWorker = require("pdfjs-dist/build/pdf.worker.entry");
// eslint-disable-next-line
import printJS from "print-js";
import moment from "moment";
export default {
  props: [
    "element",
    "navigation",
    "profile",
    "current",
    "form_info",
    "key_words",
    "specialization",
    "disableFromResponsible",
    "responsible",
    "user_setup",
  ],
  components: {
    firstStep,
    secondStep,
    thirdStep,
    documentHistory,
  },
  data() {
    return {
      isPromptAvailable: false,
      currentPage: 1,
      countPages: 1,
      deadline: 0,
      currentEdit: false,
      submittingComment: false,
      isCommentVisible: false,
      DeletePageloading: false,
      valueComment: "",
      newPages: [],
      spinning: false,
      addFileList: [],
      uploading: false,
      prew_doc_spinner: true,
      docPdf: true,
      flagRename: false,
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 10 },
      },
      labelCol: {
        xs: { span: 24 },
        sm: { span: 10 },
      },
      prew_history: false,
      prew_doc: false,
      steps: [
        {
          content: this.$t("Pre-register document"),
        },
        {
          content: this.$t("Document Description"),
        },
        {
          content: this.$t("Archiving document"),
        },
      ],
    };
  },
  computed: {
    comments() {
      if (this.element.allcomments) {
        for (let item of this.element.allcomments) {
          let user = this.form_info.data_user.find((x) => x.ID == item.author);
          item["FIO"] = user.NAME + " " + user.LAST_NAME;
          item["photo"] =
            user.PERSONAL_PHOTO != null ? user.PERSONAL_PHOTO : "";
          item.like = JSON.parse(item.like);
          item.dislike = JSON.parse(item.dislike);
          item["likes"] = item.like.length;
          item["dislikes"] = item.dislike.length;
        }
        return this.element.allcomments;
      }
      return [];
    },
  },
  methods: {
    moment,
    onClose() {
      this.isCommentVisible = false;
    },
    heightWindow() {
      // eslint-disable-next-line
      return parseInt($("#app").css("height") + 5);
    },
    onFinish() {
      this.back({});
    },
    onFinishPrompt() {
      this.isPromptAvailable = !this.isPromptAvailable;
      this.onFinish();
    },
    confirmClose() {
      if (this.isPromptAvailable == true) {
        this.$confirm({
          title: this.$t("confirm_document_close"),
          onOk: this.onFinish,
          okText: this.$t("Yes"),
          cancelText: this.$t("No"),
        });
      } else {
        this.onFinish();
      }
    },
    handleSubmitComment() {
      if (!this.valueComment) {
        return;
      }
      this.submittingComment = true;
      var comment = {
        FIO: this.profile.NAME + " " + this.profile.LAST_NAME,
        author: this.profile.ID,
        photo:
          this.profile.PERSONAL_PHOTO != null
            ? this.profile.PERSONAL_PHOTO
            : "",
        content: this.valueComment,
        likes: 0,
        like: ["23"],
        dislikes: 0,
        dislike: ["33"],
        datetime: moment().format("YYYY-MM-DD hh:mm:ss"),
      };
      this.comments.push(comment);
      this.valueComment = "";
      commentAdd([comment], this.element)
        .done((x) => {
          if (this.element.mainid == undefined) {
            let elem = JSON.parse(x);
            this.element = elem;
          }
          this.$message.success("upload comment successfully.");
        })
        .fail((e) => {
          console.error(e);
          this.$message.error("upload comment failed.");
        })
        .always(() => {
          this.submittingComment = false;

          // eslint-disable-next-line
          BX24.fitWindow();
        });
    },
    handleChangeComment(e) {
      this.valueComment = e.target.value;
    },
    dislike() {
      this.likes = 0;
      this.dislikes = 1;
      this.action = "disliked";
    },
    myPrint() {
      printJS({
        printable:
          this.element.DOWNLOAD_URL == undefined
            ? this.element.url
            : this.element.DOWNLOAD_URL,
        type: "pdf",
        showModal: true,
      });
    },
    beforeUpload(file) {
      this.addFileList = [...this.addFileList, file];
      this.handleUploadFile();
      return false;
    },
    handleUploadFile() {
      var formData = new FormData();
      formData.append("run", "filemerge");
      formData.append("ID", this.element.ID);
      formData.append("download_url", this.element.DOWNLOAD_URL);
      this.addFileList.forEach((file) => {
        formData.append("files[]", file);
      });

      this.uploading = true;
      uploadFile(formData)
        .done((x) => {
          var res = JSON.parse(x);
          for (
            let i = this.countPages + 1;
            i <= this.countPages + res.count_page;
            i++
          ) {
            this.newPages.push(i);
          }
          this.addFileList = [];
          this.uploading = false;
          this.currentPage = this.countPages + 1;
          this.getpdf();
          this.$message.success(this.$t("Upload successful") + ".");
        })
        .fail((e) => {
          this.uploading = false;
          console.error(e);
          this.$message.error(this.$t("Upload failed") + ".");
        });
    },
    showDeleteConfirm() {
      this.$confirm({
        title: this.$t("Are you sure you want to delete the current page?"),
        content: this.$t("Current page") + " - " + this.currentPage,
        okText: this.$t("Yes"),
        okType: "danger",
        cancelText: this.$t("No"),
        onOk: () => {
          this.DeletePageloading = true;
          deletePage(this.element.ID, this.currentPage)
            .done(() => {
              let index = this.newPages.indexOf(this.currentPage);
              this.newPages.splice(index, 1);
              for (let i = index; i < this.newPages.length; i++) {
                this.newPages[i]--;
              }
              this.currentPage--;
              this.countPages--;

              this.getpdf();
            })
            .fail((e) => console.error(e))
            .always(() => {
              this.DeletePageloading = false;
            });
        },
        onCancel() {},
      });
    },
    next() {
      this.currentPage++;
    },
    prev() {
      this.currentPage--;
    },
    async back(data) {
      if (this.prew_history == true) {
        this.prew_history = false;
      } else {
        this.changeSpinning();
        await editClose(this.element.mainid);
        this.$emit("back", {
          visible_doc: true,
          unshift_elem: data.unshift_elem,
          remove_elem: data.remove_elemprom,
        });
        this.changeSpinning();
      }
      document.getElementById("maindivmenu").scrollIntoView();
    },
    preview() {
      this.$emit("preview", {
        file: this.element,
        page: this.currentPage,
      });
    },
    changeSpinning() {
      this.spinning = !this.spinning;
    },
    submit() {
      this.$refs.form.submit(this.comments);
    },

    onback_history(data) {
      this.prew_history = data.prew_history;
    },
    Uint8ArrayFromBase64(base64) {
      return Uint8Array.from(window.atob(base64), (v) => v.charCodeAt(0));
    },
    getpdf() {
      let pdfAsArray = this.Uint8ArrayFromBase64(this.element.base64file);

      this.prew_doc_spinner = true;
      // var url = this.element.DOWNLOAD_URL || this.element.url;
      pdfjsLib.GlobalWorkerOptions.workerSrc = pdfjsWorker;
      // var loadingTask = pdfjsLib.getDocument(url);
      var loadingTask = pdfjsLib.getDocument(pdfAsArray);
      loadingTask.promise.then(
        (pdf) => {
          try {
            this.countPages = pdf.numPages;
            if (1 <= this.currentPage && this.countPages >= this.currentPage)
              pdf.getPage(this.currentPage).then((page) => {
                var canvas = document.getElementById("the_canvas_detail");

                let realW = $("#the_canvas_detail").width();
                var viewport = page.getViewport({
                  scale: realW / page.getViewport({ scale: 1.0 }).width,
                });
                var context = canvas.getContext("2d");
                canvas.height = viewport.height;
                canvas.width = viewport.width;
                var renderContext = {
                  canvasContext: context,
                  viewport: viewport,
                };
                page
                  .render(renderContext)
                  .promise.then(() => {
                    canvas.style.display = "unset";
                    if (this.current == 0) {
                      page.getTextContent().then((textContent) => {
                        if (textContent.items.length) {
                          let titles = textContent.items.map((x) => x.str);
                          this.bounds = [
                            {
                              label: "whole",
                              text: titles.join(" "),
                              titles,
                            },
                          ];
                          this.prew_doc_spinner = false;
                        } else {
                          // findOCR(
                          //   canvas.toDataURL("img/jpeg", 1),
                          //   this.user_setup.api_ocr_token,
                          //   url
                          // )
                          //   .done((res, state) => {
                          //     if (state == "success") {
                          //       this.bounds = res.bounds;
                          //     }
                          //   })
                          //   .catch(()=>{})
                          //   .always(() => {
                          //     this.prew_doc_spinner = false;
                          //   });
                        }
                      });
                    } else {
                      this.prew_doc_spinner = false;
                    }

                    BX24.fitWindow();
                    return page.getTextContent();
                  })
                  .then(function (textContent) {
                    var pdf_canvas = $("#the_canvas_detail");

                    var canvas_height = pdf_canvas.get(0).height;
                    var canvas_width = pdf_canvas.get(0).width;

                    $("#text-layer-step").css({
                      // left: canvas_offset.left + "px",
                      // top: canvas_offset.top + "px",
                      left: "2px",
                      top: "2px",
                      height: canvas_height + "px",
                      width: canvas_width + "px",
                    });
                    pdfjsLib.renderTextLayer({
                      textContent: textContent,

                      container: $("#text-layer-step").get(0),
                      viewport,
                      textDivs: [],
                    });
                  });
              });
          } catch {
            this.prew_doc = true;
            this.prew_doc_spinner = false;
          }
        },
        (reason) => {
          // PDF loading error
          this.prew_doc = true;
          this.prew_doc_spinner = false;
          console.error(reason);
        }
      );
    },
    // getpdf() {
    //   this.prew_doc_spinner = true;
    //   var url =
    //     this.element.DOWNLOAD_URL == undefined
    //       ? this.element.url
    //       : this.element.DOWNLOAD_URL;
    //   var pdfjsLib = window["pdfjs-dist/build/pdf"];
    //   pdfjsLib.GlobalWorkerOptions.workerSrc =
    //     "//mozilla.github.io/pdf.js/build/pdf.worker.js";
    //   var loadingTask = pdfjsLib.getDocument(url);
    //   loadingTask.promise.then(
    //     (pdf) => {
    //       try {
    //         this.countPages = pdf.numPages;
    //         if (1 <= this.currentPage && this.countPages >= this.currentPage)
    //           pdf.getPage(this.currentPage).then((page) => {
    //             var scale = 2.0;
    //             var viewport = page.getViewport({ scale: scale });
    //             var canvas = document.getElementById("the_canvas_detail");
    //             var context = canvas.getContext("2d");
    //             canvas.height = viewport.height;
    //             canvas.width = viewport.width;
    //             var renderContext = {
    //               canvasContext: context,
    //               viewport: viewport,
    //             };
    //             var renderTask = page.render(renderContext);
    //             renderTask.promise.then(() => {
    //               canvas.style.display = "unset";
    //               this.prew_doc_spinner = false;
    //             });
    //           });
    //       } catch {
    //         this.prew_doc = true;
    //         this.prew_doc_spinner = false;
    //       }
    //     },
    //     (reason) => {
    //       // PDF loading error
    //       this.prew_doc = true;
    //       this.prew_doc_spinner = false;
    //       console.error(reason);
    //     }
    //   );
    // },
    handleHistoryFile() {
      this.changeSpinning();
      let doc_id =
        this.element.mainid != undefined
          ? this.element.mainid
          : this.element.mainid;
      getHistory(doc_id).done((x) => {
        this.changeSpinning();
        this.element.HISTORY = x != "" ? JSON.parse(x) : {};
        this.prew_history = !this.prew_history;
      });
    },
    handleReturnToNew() {
      this.changeSpinning();
      returnToNew(this.element.mainid)
        .done(() => {
          this.back({ remove_elem: this.element.ID });
          this.$message.success(this.$t("Back to description"));
        })
        .fail((e) => console.error(e))
        .always(() => this.changeSpinning());
    },
    handleReturnToDesc() {
      this.changeSpinning();
      returnToDescription(this.element.mainid)
        .done(() => {
          this.back({ remove_elem: this.element.ID });
          this.$message.success(this.$t("Back to description"));
        })
        .fail((e) => console.error(e))
        .always(() => this.changeSpinning());
    },
    getUser(id) {
      let user = this.form_info.data_user.find((x) => x.ID == id);
      return user.NAME + " " + user.LAST_NAME;
    },
    resize() {
      // eslint-disable-next-line
      BX24.resizeWindow(
        parseInt(
          // eslint-disable-next-line
          $("body>div>.ant-spin-nested-loading>.ant-spin-container").css(
            "width"
          )
        ),
        parseInt(
          // eslint-disable-next-line
          $("body>div>.ant-spin-nested-loading>.ant-spin-container").css(
            "height"
          )
        )
      );
    },
  },
  mounted() {
    if (
      this.element.NAME.indexOf(".jpg") != -1 ||
      this.element.NAME.indexOf(".png") != -1
    ) {
      this.docPdf = false;
      this.prew_doc_spinner = false;
    } else {
      this.getpdf();
    }
    if (this.profile.ID == this.element.currentlyeditor) {
      this.currentEdit = true;
    }
    this.deadline = Date.now() + 1000 * 600;
  },
  updated() {
    this.resize();
  },
};
</script>

<style scoped>
.appBlock {
  display: flex;
  text-align: left;
  flex-direction: column;
  justify-content: flex-start;
  margin: auto;
}
.appBlock .title {
  font-size: 24px;
}

.steps {
  display: flex;
  justify-content: space-between;
  margin-bottom: 25px;
}
.steps > div:first-child {
  width: 100%;
  padding: 15px 0px;
}
.steps > div:last-child {
  align-self: center;
}

.mainBlock--form > div:first-child {
  display: flex;
}
.mainBlock--btn {
  margin-top: 20px;
}

#the_canvas_detail {
  margin-top: 5px;
}

.iconBtn {
  margin: 0 25px;
  font-size: 20px;
}

.iconBtn:hover {
  color: #1890ff;
}

.iconBtnClose:hover {
  color: #f5222d;
}
</style>
